import {Component} from 'react'
import {Redirect} from 'react-router-dom'
import Cookies from 'js-cookie'

import AppContext from '../../context/AppContext'

import {
  AppContainer,
  LoginCard,
  LogoImg,
  FormContainer,
  InputContainer,
  InputLabel,
  InputEl,
  CheckboxContainer,
  CheckboxInput,
  CheckboxLabel,
  ErrMsgPara,
  LoginBtn,
} from './styledComponents'

class Login extends Component {
  state = {
    isChecked: false,
    username: '',
    password: '',
    showSubmitError: false,
    errMsg: '',
    isPasswordDisplay: false,
  }

  onSubmitSuccess = jwtToken => {
    const {history} = this.props
    Cookies.set('jwt_token', jwtToken, {
      expires: 30,
      path: '/',
    })
    history.replace('/')
  }

  onSubmitFailure = errMsg => {
    this.setState({
      showSubmitError: true,
      errMsg,
    })
  }

  onChangeUsername = event => {
    this.setState({username: event.target.value})
  }

  onChangePassword = event => {
    this.setState({password: event.target.value})
  }

  handleCheckbox = () => {
    this.setState(prevState => ({
      isChecked: !prevState.isChecked,
      isPasswordDisplay: !prevState.isPasswordDisplay,
    }))
  }

  submitForm = async event => {
    event.preventDefault()
    const {username, password} = this.state
    const apiUrl = 'https://apis.ccbp.in/login'
    const userDetails = {username, password}
    const options = {
      method: 'POST',
      body: JSON.stringify(userDetails),
    }
    const response = await fetch(apiUrl, options)
    const data = await response.json()
    if (response.ok) {
      this.onSubmitSuccess(data.jwt_token)
    } else {
      this.onSubmitFailure(data.error_msg)
    }
  }

  render() {
    const jwtToken = Cookies.get('jwt_token')

    if (jwtToken !== undefined) {
      return <Redirect to="/" />
    }
    console.log('render calleds')
    return (
      <AppContext.Consumer>
        {value => {
          const {
            showSubmitError,
            isChecked,
            username,
            password,
            errMsg,
            isPasswordDisplay,
          } = this.state
          const {theme} = value
          return (
            <AppContainer theme={theme}>
              <LoginCard theme={theme}>
                <FormContainer theme={theme} onSubmit={this.submitForm}>
                  {!theme ? (
                    <LogoImg
                      src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png"
                      alt="website logo"
                    />
                  ) : (
                    <LogoImg
                      src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-dark-theme-img.png"
                      alt="website logo"
                    />
                  )}
                  <InputContainer theme={theme}>
                    <InputLabel htmlFor="username" theme={theme}>
                      USERNAME
                    </InputLabel>
                    <InputEl
                      theme={theme}
                      id="username"
                      type="text"
                      value={username}
                      placeholder="Username"
                      onChange={this.onChangeUsername}
                    />
                  </InputContainer>
                  <InputContainer theme={theme}>
                    <InputLabel htmlFor="password" theme={theme}>
                      PASSWORD
                    </InputLabel>
                    <InputEl
                      theme={theme}
                      id="password"
                      type={isPasswordDisplay ? 'text' : 'password'}
                      value={password}
                      placeholder="password"
                      onChange={this.onChangePassword}
                    />
                  </InputContainer>
                  <CheckboxContainer>
                    <CheckboxInput
                      type="checkbox"
                      checked={isChecked}
                      value="checkbox"
                      id="checkbox"
                      onChange={this.handleCheckbox}
                    />
                    <CheckboxLabel theme={theme} htmlFor="checkbox">
                      Show Password
                    </CheckboxLabel>
                  </CheckboxContainer>
                  <LoginBtn type="submit">Login</LoginBtn>
                  {showSubmitError && (
                    <ErrMsgPara theme={theme}>*{errMsg}</ErrMsgPara>
                  )}
                </FormContainer>
              </LoginCard>
            </AppContainer>
          )
        }}
      </AppContext.Consumer>
    )
  }
}

export default Login
